"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XSRF_HEADER = exports.DEFAULT_XSRF_COOKIE_NAME = void 0;
/* istanbul ignore file */
exports.DEFAULT_XSRF_COOKIE_NAME = "XSRF-TOKEN";
exports.XSRF_HEADER = "X-XSRF-TOKEN";
